import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { DropdownList } from "react-widgets";
import {
  Controller,
  useForm,
} from "../../../../../node_modules/react-hook-form/dist";
import api from "../../../../api";
import RemoteDataDropDown from "../../../../components/dropdown/RemoteDataDropDown";
import RemoteDataMultiSelectDropDown from "../../../../components/dropdown/RemoteDataMultiSelectDropDown";
import { DateInput } from "../../../../components/form-group";
import { DragDropUploadPDF } from "../../../../components/upload";
import { MediaFile, ProposedProperty } from "../../../../core";
import PDFViewer from "./PDFViewer";
import CalenderIco from "../../../../assets/images/calender-ico.png";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { FileFormats } from "../../../../utils/fileFormats";
export interface FormProps {
  signedClientId?: string;
  signedLandlordId?: string;
  landlordSignedDate?: Date;
  clientSignedDate?: Date;
  agreementExpiryDate?: Date;
  documentId?: string;
}

const SignedTimesheet: React.FunctionComponent<{
  versions?: any[];
  proposalId?: string;
  documentSettingsId?: string;
  documentId?: string;
  onSuccess?: (doc: any) => void;
  title?: string;
  signedDocument?: any;
  noBoarder?: boolean;
  hideVersion?: boolean;
  hideLandlordCopy?: boolean;
  hideClientCopy?: boolean;
  proposedPropertyId?: string;
  proposalDocuments?: any[];
}> = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [signedFile, setSignedFile] = useState<MediaFile>();

  const [showEdit, setShowEdit] = useState(false);

  const loadShowroom = async () => {
    const response = await api.proposal.getParticipants(props.proposalId);
    return response;
  };

  const loadLandLords = async () => {
    const type = "doc";
    const response = await api.sitevisit.getLandLords(
      props?.proposedPropertyId!,
      type
    );

    return response;
  };

  const onFileChosen = (file?: MediaFile) => {
    setSignedFile(file!);
  };

  const { control, handleSubmit, errors, watch, setValue } = useForm<FormProps>(
    {
      reValidateMode: "onChange",
      mode: "onSubmit",
    }
  );

  const onSubmit = async (data: FormProps) => {
    setIsSubmitting(true);
    const createProposalData = {
      documentSettingsId: props?.documentSettingsId,
      signedClientId: data.signedClientId,
      signedLandlordId: data.signedLandlordId,
      landlordSignedDate: data.landlordSignedDate,
      clientSignedDate: data.clientSignedDate,
      agreementExpiryDate: data.agreementExpiryDate,
      signedFile,
    };
    const signedDoc = await api.proposalDocument.approveOnSigned(
      createProposalData,
      data.documentId || props.documentId!
    );
    setIsSubmitting(false);
    toastr.success("Success", `Signed ${props.title} successfully uploaded`);
    props.onSuccess?.(signedDoc?.signedClientDocument);
    setShowEdit(false);
    setSignedFile(undefined);
  };

  const signedTermSheet = props.proposalDocuments?.filter(
    (x) => x.stageCode === "term_sheet_submission" && x.signedClientDocument
  );

  const signedLoi = props.proposalDocuments?.filter(
    (x) => x.stageCode === "letter_of_intent" && x.signedClientDocument
  );

  const signedFeeConfirmations = props.proposalDocuments?.filter(
    (x) =>
      x.stageCode === "fee_confirmation" &&
      (x.signedClientDocument || x.signedLandlordDocument)
  );

  const renderFile = () => {
    return (
      <div className="row gutter-10">
        <div className="col-sm-12 col-12">
          <div className="form-group font-weight-semibold mb-0">
            <div className="drag-drop-file  position-relative time-sheet-upload">
              <DragDropUploadPDF
                name="timeSheet"
                id="timeSheet"
                onFileChosen={onFileChosen}
                title={`Upload ${props.title}`}
                accept={FileFormats}
                // accept={[".pdf", ".doc", ".docx"]}
              />
              {/* <span className="ml-1 font-xxs text-danger font-weight-normal text-gray-500">
                Note: Only PDF files are accepted
              </span> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return !signedFile ? (
    <>
      {props.signedDocument && !showEdit ? (
        <div
          className={`bg-white ${
            props.noBoarder ? "" : "border"
          } rounded-sm signed-time-wrap`}
        >
          <div className="px-4 py-3">
            <div className="row no-gutters">
              <div className="col-md-6 col-12 ">
                <div className="d-flex align-items-center">
                  <div>
                    <h5 className="font-normal font-sm font-weight-semibold mb-0">
                      Signed {props.title} V
                      {props.signedDocument?.versionNumber}
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 align-items-center d-md-flex mt-3 mt-md-0 justify-content-end">
                <ul
                  className="list-unstyled d-flex border-right border font-weight-semibold"
                  style={{ backgroundColor: "#f4f3fa" }}
                >
                  {/* <li
                    className="px-2 font-xs border-right d-flex align-items-center py-1 cursor-pointer"
                    style={{ lineHeight: "inherit" }}
                    onClick={() => {
                      // props.setResolveDocuments();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-2"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M9.75 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6.75L9.75 1.5Z"
                        stroke="#3F4241"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.75 1.5V6.75H15"
                        stroke="#3F4241"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>{" "}
                    Docx Download
                  </li> */}

                  <li
                    className="px-2 font-xs d-flex align-items-center py-1 cursor-pointer"
                    style={{ lineHeight: "inherit" }}
                    onClick={() => setShowEdit(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      className="mr-2"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M11.4961 1.99955C11.6712 1.82445 11.8791 1.68556 12.1078 1.5908C12.3366 1.49604 12.5818 1.44727 12.8294 1.44727C13.0771 1.44727 13.3222 1.49604 13.551 1.5908C13.7798 1.68556 13.9877 1.82445 14.1628 1.99955C14.3379 2.17465 14.4768 2.38252 14.5715 2.61129C14.6663 2.84006 14.715 3.08526 14.715 3.33288C14.715 3.58051 14.6663 3.8257 14.5715 4.05448C14.4768 4.28325 14.3379 4.49112 14.1628 4.66622L5.16276 13.6662L1.49609 14.6662L2.49609 10.9996L11.4961 1.99955Z"
                        stroke="#3F4241"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Edit
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-4">
              <PDFViewer
                pdfUrl={props.signedDocument?.document?.location!}
                file={props.signedDocument?.document}
              ></PDFViewer>
            </div>
          </div>
        </div>
      ) : (
        <div className="row m-0">
          <div className="col-12 bg-white pt-3   border pl-0 pr-0 rounded-sm">
            <div className="d-flex align-items-center mb-3 px-3">
              <label className="font-md font-weight-semibold mb-0">
                Signed {props.title}
              </label>
            </div>
            <div className="w-100">
              <div>{renderFile()}</div>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <div className="row m-0">
      <div className="col-12 bg-white pt-3  border  pl-0 pr-0 rounded-sm">
        <div className="mb-3 px-3">
          <h6 className="font-normal">Signed {props.title} </h6>
        </div>
        {/* <label className="bg-lightblue border-bottom border-top d-block font-weight-semibold font-xs mb-0 px-3 py-3">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                stroke="#4161C8"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14 2V8H20"
                stroke="#4161C8"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 13H8"
                stroke="#4161C8"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 17H8"
                stroke="#4161C8"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10 9H9H8"
                stroke="#4161C8"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>{" "}
          <span className="text-primary pl-1 font-weight-lighter">
            {" "}
            {signedFile?.originalname}
          </span>
        </label> */}
        <div className="w-100 p-3 termsheet-upload-wrap">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gutter-8 mb-md-4 mb-3 pb-3">
              {!props.hideVersion && (
                <div className="col-md-5 col-12">
                  <label
                    htmlFor=""
                    className="font-normal font-weight-semibold"
                  >
                    Choose uploaded agreement version
                  </label>
                  <div className="max-w-100">
                    <Controller
                      control={control}
                      name="documentId"
                      defaultValue={props?.documentId}
                      render={({ onChange, value, name }) => (
                        <DropdownList
                          value={value}
                          defaultValue={value}
                          data={props?.versions?.map((x) => {
                            return {
                              versionNumber: x.document?.versionNumber,
                              _id: x._id,
                            };
                          })}
                          textField={"versionNumber"}
                          valueField={"_id"}
                          placeholder={"Select version"}
                          onChange={(val) => {
                            onChange(val._id);
                          }}
                          filter={"contains"}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="row gutter-8">
              {!props.hideClientCopy && (
                <>
                  <div className="col-md-6 col-12 mb-3">
                    <label
                      htmlFor=""
                      className="font-normal font-weight-semibold"
                    >
                      Client Acceptance & Agreed By<span className="text-danger">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="signedClientId"
                      rules={{ required: true }}
                      render={({ onChange, value, name }) => (
                        <RemoteDataDropDown
                          loadData={loadShowroom}
                          textField="firstLastName"
                          value={value}
                          defaultValue={value}
                          valueField="_id"
                          onChange={(val) => {
                            onChange(val._id);
                          }}
                          placeholder="Select User"
                        ></RemoteDataDropDown>
                      )}
                    />
                    {errors.signedClientId && (
                      <ErrorMessage>
                        Client Acceptance & Agreed By is required
                      </ErrorMessage>
                    )}
                  </div>
                  <div className="col-md-6 col-12 mb-3">
                    <label
                      htmlFor=""
                      className="font-normal font-weight-semibold"
                    >
                      Date of Signed<span className="text-danger">*</span>
                    </label>
                    <div className="row gutter-5">
                      <div className="col-12">
                        <Controller
                          control={control}
                          name="clientSignedDate"
                          rules={{ required: true }}
                          render={({ onChange, value, name }) => (
                            <DateInput
                              default={value}
                              placeholder={" Date of Signed"}
                              onChange={onChange}
                              maxDate={new Date()}
                            />
                          )}
                        />
                        {errors.clientSignedDate && (
                          <ErrorMessage>
                            Date of Signed is required
                          </ErrorMessage>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
              {!props.hideLandlordCopy && (
                <>
                  <div className="col-md-6 col-12 mb-3">
                    <label
                      htmlFor=""
                      className="font-normal font-weight-semibold"
                    >
                      Vendor / Owner Acceptance Agreed By<span className="text-danger">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="signedLandlordId"
                      rules={{ required: true }}
                      render={({ onChange, value, name }) => (
                        <RemoteDataDropDown
                          loadData={loadLandLords}
                          textField="contactName"
                          value={value}
                          defaultValue={value}
                          valueField="customerId"
                          onChange={(val) => {
                            onChange(val.customerId);
                          }}
                          placeholder="Select User"
                        ></RemoteDataDropDown>
                      )}
                    />
                    {errors.signedLandlordId && (
                      <ErrorMessage>
                        Vendor/ Owner Acceptance & Agreed By is required
                      </ErrorMessage>
                    )}
                  </div>
                  <div className="col-md-6 col-12 mb-3">
                    <label
                      htmlFor=""
                      className="font-normal font-weight-semibold"
                    >
                      Date of Signed<span className="text-danger">*</span>
                    </label>
                    <div className="row gutter-5">
                      <div className="col-12">
                        <Controller
                          control={control}
                          name="landlordSignedDate"
                          rules={{ required: true }}
                          render={({ onChange, value, name }) => (
                            <DateInput
                              default={value}
                              placeholder={" Date of Signed"}
                              onChange={onChange}
                              maxDate={new Date()}
                            />
                          )}
                        />
                        {errors.landlordSignedDate && (
                          <ErrorMessage>
                            Date of Signed is required
                          </ErrorMessage>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
              {props.title === "Agreement" && <div className="col-md-6 col-12 mb-3">
                    <label
                      htmlFor=""
                      className="font-normal font-weight-semibold"
                    >
                      Agreement Expiry Date
                    </label>
                    <div className="row gutter-5">
                      <div className="col-12">
                        <Controller
                          control={control}
                          name="agreementExpiryDate"
                          // rules={{ required: true }}
                          render={({ onChange, value, name }) => (
                            <DateInput
                              default={value}
                              placeholder={" Agreement Expiry Date"}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.agreementExpiryDate && (
                          <ErrorMessage>
                            Agreement Expiry Date is required
                          </ErrorMessage>
                        )}
                      </div>
                    </div>
              </div>}
              <div className="col-md-12 col-12 mb-3">
                <div className="mt-4">
                  <PDFViewer
                    pdfUrl={signedFile?.location!}
                    file={signedFile}
                  ></PDFViewer>
                </div>
              </div>
              <div className="form-group font-weight-semibold mb-3 text-right pt-3 col-12 px-2">
                <button
                  type="button"
                  className="btn btn-outline-dark border font-weight-semibold font-normal  mr-2"
                  onClick={() => setSignedFile(undefined)}
                >
                  <span className="px-3">Cancel</span>
                </button>
                <button
                  disabled={isSubmitting}
                  className="btn btn-primary font-weight-semibold font-normal"
                >
                  <span className="px-3">Submit</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignedTimesheet;
